import React, { useCallback } from 'react'

import styled from 'styled-components'

import { ButtonProps } from '@customTypes'
import { RingLoader } from '_components/loader'
import { noop } from '_helpers/functions'

import { StyledButton } from './components'

const StyledLoader = styled(RingLoader)`
  margin-left: 0.5rem;
`

const defaultLoader = () => <StyledLoader color="inherit" />

const ButtonComponent: React.FC<ButtonProps> = React.forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, 'ref'>
>((
  {
    children,
    shouldShowLoader,
    onClick = noop,
    renderLoader = defaultLoader,
    ...props
  },
  ref
) => {
  const { isDisabled, isLoading } = props

  const onClickButton: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    e => {
      if (isDisabled) {
        e.preventDefault()

        return
      }

      if (onClick) {
        onClick(e)
      }
    },
    [onClick, isDisabled]
  )

  return (
    <StyledButton
      ref={ref}
      isDisabled={isDisabled}
      onClick={onClickButton}
      aria-disabled={isDisabled}
      aria-busy={isLoading}
      aria-live="polite"
      {...props}
    >
      {children}
      {shouldShowLoader && isLoading && renderLoader()}
    </StyledButton>
  )
})

export const Button = styled(ButtonComponent)``
